<template>
  <div class="dashboard-container">
    <el-card shadow="hover">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="免责声明" name="first">
          <el-form :model="manForm" status-icon  ref="manForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="" >
              <el-input v-model="manForm.id" v-show="false"/>
            </el-form-item>
            <el-form-item label="" prop="content">
              <Tinymce ref="editor" v-model="manForm.content" height="400" width="800"/>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleSubmit('manForm')">保存</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import { getByType, update, add, del } from '@/api/content/contentconfig'
import { pluck, equals } from 'ramda'
import Tinymce from '@/components/Tinymce'
import { getDashboard, getUserRegStatistics } from '@/api/dashboard'
import dayjs from 'dayjs'
import { numColorMap } from '@/views/dashboard/const'
import {list} from "@/api/content/appversion";
export default {
  name: 'Dashboard',
  components: {
    Tinymce
  },
  data() {
    return {
      activeName: 'first',
      numColorMap,
      manForm: {
        type:3,
        id:"",
        content: ""
      },
      womanForm: {
        type:4,
        id:"",
        content: ""
      },
      // 表单校验
      rules: {
        content: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
      },
      lineOptions: {},
      queryParams: {},
      infoList: [],
      loading: false,
      currMonth: dayjs().format('YYYY-MM')
    }
  },
  created() {
    this.initData(2)
  },
  methods: {

    initData(type) {
      this.queryParams.type = type
      getByType(this.queryParams).then(response => {
        this.manForm = response.data
      })
    },
    handleSubmit: function(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          let params ={}
          let id = ""
          if ("manForm"===form){
            id = this.manForm.id
            params = this.manForm;
          }
          if (id) {
            update(id, params).then(() => {
              this.$message.success('修改成功')
            })
          } else {
            add(params).then(() => {
              this.$message.success('新增成功')
              this.initData(2)
            })
          }
        }
      })
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },

  }
}
</script>

<style lang="scss" scoped>
.echarts {
  width: 90%;
  height: 90%;
}
.dashboard {
  &-container {
    margin: 10px;
    margin-top: 35px;
    &-text-descriptions {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      margin-left: 63px;
      margin-top: -10px;
      .description-row {
        display: flex;
        width: 100px;
        flex-direction: column;
        margin-right: 15%;
        margin-top: 20px;
        &-column {
          .title {
            font-size: 15px;
            margin-top: 9px;
          }
          .total-num {
            margin-top: 9px;
          }
          .yesterday-row {
            font-size: 12px;
            margin-top: 9px;
            color: rgba(16, 16, 16, 0.52);
            display: flex;
            .yesterday-title {
              min-width: 30px;
            }
            .yesterday-count {
              margin-left: 5px;
            }
          }
        }
      }
    }
    .user-reg-statistics {
      width: 100%;
      height: 500px;
      margin-top: 20px;
    }
  }
  &-title {
    font-size: 20px;
    margin-left: 63px;
    margin-top: 10px;
  }
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
</style>
